"use strict";
// packages/contracts/src/portal.ts — Fase 17, Plano 02 (PORT-01, PORT-02; D-07, D-21, D-27).
// Contrato do portal do cliente (API <-> app do portal). SOMENTE tipos: nenhum valor em tempo de execução, para o
// bundle do portal nunca puxar enums/constantes do backend interno. Cada campo é uma whitelist deliberada: o portal
// nunca expõe preço, OP, NF de entrada, observações internas, refugo ou identificadores internos (D-07, D-27).
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=portal.js.map